import React, { useState, useEffect } from "react"
import Modal from "react-bootstrap/Modal"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import "./ChemoOrder.scss"
import CompletedOrder from "./CompletedOrder"
import Row from "react-bootstrap/esm/Row"
import Col from "react-bootstrap/esm/Col"
import PermissionUtils from "../../../../core/store/utils/PermissionUtils"
import { useSelector } from "react-redux"
import PendingOrder from "./PendingOrder"
import AddNewChemoOrderWS from "./AddNewChemoOrderWS"
import { calculateAge } from "core/utils/date"
import { getCenterDetail } from "core/services/api/masterService"
import AddNewChemoOrder from "./AddNewChemoOrder"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

function ChemoOrder({ closePrintModal, patientMOC, readOnly, smartSummaryDetails, appointmentDetails }: any) {
  const [show, setShow] = useState(true)
  const [value, setValue] = React.useState(0)
  const [center, setCenter] = useState<any>()

  const userRole = useSelector((state: any) => state?.user?.role)
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  useEffect(() => {
    if (userDetail && userDetail?.currentCenter && userDetail?.currentCenter?.centerId) {
      getCenterDetail(`${userDetail?.currentCenter?.centerId}`)
        .then((res: any) => {
          if (res) {
            setCenter(res)
          }
        })
        .catch((err: any) => {
          console.log("Center error", err)
        })
    }
  }, [userDetail])

  const handleClose = () => {
    setShow(false)
    closePrintModal(false)
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <div>
      <Modal className="modal-chemo" size="xl" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col className="basic-patient-details">
                {PermissionUtils.displayPatientName(
                  userRole,
                  patientMOC,
                  false,
                  null,
                  "-"
                )}
                {patientMOC?.mocId}-{patientMOC?.gender}-{calculateAge(patientMOC?.dob)}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "5px" }}>
          <Row className="heading-test" style={{ paddingLeft: "25px" }}>
            Chemo Order
          </Row>
          <Box sx={{ padding: "15px", marginTop: "20px" }}>
            <Box>
              <Tabs
                TabIndicatorProps={{
                  sx: {
                    bgcolor: "blue",
                    height: "2px",
                    color: "blue",
                  },
                }}
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Chemo Order"
                  {...a11yProps(0)}
                />
                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                  label="Pending Order"
                  {...a11yProps(1)}
                />

                <Tab
                  sx={{
                    textTransform: "none",
                    fontSize: "20px",
                    fontWeight: "700",
                    borderRadius: "0px",
                  }}
                  label="Completed Order"
                  {...a11yProps(1)}
                />

              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              {
                (center && center?.isWondersoftEnabled) ?
                  <AddNewChemoOrderWS
                    patientInfo={patientMOC}
                    isEditableOrder={false}
                    readOnly={readOnly}
                    smartSummaryDetails={smartSummaryDetails}
                    redirectPendingOrder={(val: any) => {
                      setValue(val);
                    }}
                    pendingOrDelete={false}
                  ></AddNewChemoOrderWS> : <AddNewChemoOrder
                    patientInfo={patientMOC}
                    isEditableOrder={false}
                    readOnly={readOnly}
                    smartSummaryDetails={smartSummaryDetails}
                    redirectPendingOrder={(val: any) => {
                      setValue(val);
                    }}
                    pendingOrDelete={false}
                  />
              }
            </TabPanel>
            <TabPanel value={value} index={1}>
              <PendingOrder
                patientInfo={patientMOC}
                readOnly={readOnly}
                smartSummaryDetails={smartSummaryDetails}
                appointmentDetails={appointmentDetails}
                center={center}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <CompletedOrder
                patientInfo={patientMOC}
                readOnly={readOnly}
                smartSummaryDetails={smartSummaryDetails}
                appointmentDetails={appointmentDetails}
                center={center}
              />
            </TabPanel>
          </Box>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ChemoOrder
